module.exports = __webpack_public_path__ + "static/media/plan-TH4-mobile-en.2c72e591.png";